import React from 'react';
import Modal from 'react-bootstrap/Modal';
import ProgressBar from 'react-bootstrap/ProgressBar';

function ProgressModal({
  show = false,
  title = 'Processando...',
  progress = 0,
  current = 0,
  total = 1,
  errors = 0,
  onCancel = null,
}) {
  const progressPercentage = Math.round(progress * 100);

  return (
    <Modal show={show} backdrop="static" keyboard={false} centered>
      <Modal.Header closeButton={!!onCancel}>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          <ProgressBar
            now={progressPercentage}
            label={`${progressPercentage}%`}
            striped
            animated
            variant={errors > 0 ? 'warning' : 'primary'}
          />
        </div>
        <div className="d-flex justify-content-between mb-2">
          <span>
            Progresso: {current} de {total}
          </span>
          {errors > 0 && <span className="text-danger">Erros: {errors}</span>}
        </div>
        {onCancel && (
          <div className="d-grid mt-3">
            <button className="btn btn-outline-danger" onClick={onCancel}>
              Cancelar Operação
            </button>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default ProgressModal;
